import { Image } from 'components/ui-kit';
import { Container } from 'components/ui-kit/grid';
import { CSSProperties, type JSX } from 'react';
import styles from './quiz-result.module.scss';
import { Box } from '../../components/box';

type TQuizResultViewProps = {
  score: number;
};

type TResult = {
  title: string;
  image: string;
  content: JSX.Element;
};
const getResult = (score: number): TResult => {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (score > 6) {
    return {
      title: 'Изобретательный утконос',
      image: '/images/collaborations/utkonos/smart.svg',
      content: (
        <>
          <p>
            Главное для вас&nbsp;&mdash; не&nbsp;сидеть на&nbsp;месте, потому
            что в&nbsp;мире ещё столько всего, что можно изменить
            к&nbsp;лучшему. А&nbsp;вам это точно под силу&nbsp;&mdash;
            мы&nbsp;уверены. Ваше кредо&nbsp;&mdash; меняться самому
            и&nbsp;менять обстановку вокруг. Вы&nbsp;часто предлагаете свежие
            идеи, которые потом становятся нормой рынка. Главное
            не&nbsp;останавливаться на&nbsp;достигнутом!
          </p>
          <p>
            &laquo;Чего&nbsp;же ты&nbsp;ждёшь?&raquo;&nbsp;&mdash; фраза,
            которая поможет не&nbsp;останавливаться на&nbsp;достигнутом.
            Забирайте лимитированный лонгслив с&nbsp;утконосом и&nbsp;покоряйте
            в&nbsp;нём новые вершины!
          </p>
        </>
      ),
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (score > 2) {
    return {
      title: 'Зажигательный утконос',
      image: '/images/collaborations/utkonos/fire.svg',
      content: (
        <>
          <p>
            Вы&nbsp;умеете находить вдохновение в&nbsp;обыденном и&nbsp;видите
            лучики света даже среди самых тёмных туч!
          </p>
          <p>
            А&nbsp;чтобы сделать мир веселее было проще, воспользуйтесь
            объёмными стикерами &mdash; их&nbsp;можно приклеить куда угодно!
          </p>
        </>
      ),
    };
  }
  return {
    title: 'Всевидящий утконос',
    image: '/images/collaborations/utkonos/all-seeing.svg',
    content: (
      <>
        <p>
          Дальновидные решения&nbsp;&mdash; ваш конёк! Всевидящий утконос тонко
          чувствует, что и&nbsp;когда важно изменить.
        </p>
        <p>
          Меняйся и&nbsp;меняй&nbsp;&mdash; девиз, который помогает
          не&nbsp;только оставаться на&nbsp;волне, но&nbsp;и&nbsp;ставить
          амбициозные цели в&nbsp;будущем! А&nbsp;стальной унисекс-браслет
          станет напоминанием о&nbsp;главном.
        </p>
      </>
    ),
  };
};
export const QuizResultView = ({
  score,
}: TQuizResultViewProps): JSX.Element => {
  const result = getResult(score);

  return (
    <Container>
      <Box
        className={styles.wrapper}
        style={{ '--image': `url('${result.image}')` } as CSSProperties}
      >
        <div className={styles.contentWrapper}>
          <h1 className={styles.title}>{result.title}</h1>
          <Image
            className={styles.image}
            src={result.image}
            alt={result.title}
          />
          <div className={styles.content}>{result.content}</div>
        </div>
      </Box>
    </Container>
  );
};
